import { Component, OnInit } from "@angular/core";
import { UserTypeModel } from "src/models/usertypes.model";
import { MatDialogRef } from "@angular/material";
import { FormsService } from "../../providers/forms.service";
import { UtilsProvider } from "../../commons/utils";

@Component({
	selector: "app-modal-define-user-type",
	templateUrl: "./modal-define-user-type.component.html",
	styleUrls: ["./modal-define-user-type.component.scss"]
})
export class ModalDefineUserTypeComponent implements OnInit {
	public fields: any[] = [{
		title: "",
	}];
	public title: any;
	public type: any;
	public mask: any;
	public validations = [
		{
			// title: "Obrigatório",
			type: "required",
			value: ""
		},
		{
			// title: "Máscara",
			type: "mask",
			value: ""
		},
		{
			// title: "Máscara",
			type: "crm",
			value: ""
		},
		{
			// title: "Data",
			type: "mask-date",
			value: "00/00/0000"
		}
	];
	public tipos = [
		{
			title: "Número",
			type: "number"
		},
		{
			title: "Texto",
			type: "text"
		},
		{
			title: "Data",
			type: "date"
		},
		{
			title: "Arquivo",
			type: "file"
		},
		{
			title: "CRM válido",
			type: "crm"
		},
	];
	constructor(
		public dialogRef: MatDialogRef<ModalDefineUserTypeComponent>,
		public userTypesModel: UserTypeModel,
		public formProvider: FormsService,
		public utils: UtilsProvider,
	) { }

	ngOnInit() {

	}

	addField() {
		this.fields.push({
			title: ""
		});
	}

	removeField(i: number) {
		this.fields.splice(i, 1);
	}

	submitType() {
		if (!this.title || this.title === " ") {
			return alert("O título do campo é obrigatório");
		}
		const field = {
			title: this.title,
			alias: this.getAlias(this.title),
			type: this.type,
			validations: this.getValidations()
		};
		// this.userTypesModel.setField(field);
		this.formProvider.saveField(field).then(res => {
			this.dialogRef.close(res);
		}).catch(e => {
			// return alert(e);
			return this.utils.toast({
				message: "Não foi possível cadastrar este campo do formulário no sistema, tente novamente mais tarde",
				duration: 8000,
				action: "Ok"
			});
		});

	}
	getValidations() {
		const val = [this.validations[0]];
		if (this.type !== "date" && this.type !== "crm" && this.mask) {
			val.push({
				type: "mask",
				value: this.mask
			});
		} else if (this.type === "date") {
			val.push({
				type: "mask",
				value: "00/00/0000"
			});
		} else if (this.type === "crm") {
			val.push({
				type: "crm",
				value: "0?0?0?0?0?0?0?00"
			});
		}
		return val;
	}
	getAlias(str) {
		return this.utils.getAlias(str);
	}

}
